var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GridItem',{attrs:{"x":_vm.item.x,"y":_vm.item.y,"w":_vm.item.w,"h":_vm.item.h,"i":_vm.item.i}},[_c('div',{class:'widget ' + (_vm.isEditing && (_vm.item.i % 2 === 0 ? 'shake2' : 'shake1')),style:({
      'animation-duration':
        Math.floor(Math.random() * (0.5 - 0.3)) + 0.3 + 's',
    })},[_c(_vm.item.widget,{tag:"Widget",attrs:{"dateRange":_vm.dateRange}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }